import styled, { css } from 'styled-components/macro'
import { shake } from 'styles/global'
import { ITheme } from 'styles/types'

export const CustomInput = styled.input<{
  hasError: boolean
  textColor: string
  disabled?: boolean
  leftAligned?: boolean
}>`
  width: 100%;
  height: 36px;
  outline: none;
  text-align: ${({ leftAligned }) => (leftAligned ? 'left' : 'center')};
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid white;
  color: ${({ disabled }) => (disabled ? 'rgba(255,255,255, 0.5)' : '#fff')};
  border-radius: 8px;
  background: ${({ hasError, theme }) => (hasError ? theme.palette.error : 'transparent')};
  display: inline-block;
  animation: ${({ hasError }) =>
    hasError
      ? css`
          ${shake} 0.6s linear
        `
      : ''};

  :focus {
    background: ${({ hasError, theme }) => (hasError ? theme.palette.error : '#fff')};
    color: ${({ textColor, hasError }) => (hasError ? '#fff' : textColor)};
  }
  &::placeholder {
    text-align: center;
    font-family: 'Calibri';
    font-family: 'AvenirNextCondensedRegular';
    font-size: 18px;
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  @media (max-height: 450px) {
    height: 30px;
  }

  @media (max-width: 600px) and (min-height: 451px) {
    line-height: 30px;
  }

  @media ${({ theme }: { theme: ITheme }) => theme.breakpoints.sm} {
    padding-top: 5px;
  }
`
